module.exports = __webpack_public_path__ + "static/NOOBS_SHORT_LOGO-7edbd7474f99cc209a9d9f40c6ded756.png";